import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import styles from './InformationModal.css';

class InformationModal extends React.Component {
  render() {
    return (
      <Modal
        show={this.props.show}
        onHide={() => {}}
        dialogClassName={styles.dialog}
      >
        <Modal.Header>
          <span className={styles.title}>Information</span>
        </Modal.Header>
        <Modal.Body>Error: {this.props.message}</Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-default"
            onClick={this.props.onHide}
          >
            OK
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}

InformationModal.propTypes = {
  show: PropTypes.bool,
  message: PropTypes.message,
  onHide: PropTypes.func,
};
export default InformationModal;
